<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Prelims-head" id="_idParaDest-3"><a id="_idTextAnchor002"></a>Acknowledgements</p>
<p class="Prelims-main">Thank you again to my lovely late mother Peggy, for having the patience to listen to, read and critique each of the poems in my collection, in tandem with her indefatigable belief in me during the toughest of times we both shared. <em class="italic _idGenCharOverride-1">I love you Mama</em>. </p>
<p class="Prelims-main">I would also like to acknowledge and thank <em class="italic _idGenCharOverride-1">the</em> most remarkable, wonderful and intelligent woman I have ever known, <em class="italic _idGenCharOverride-1">Sikiu Martinez</em>, a woman who moved my very soul; whom I will always remember as <em class="italic _idGenCharOverride-1">mi hermosa Latina</em>, the amazing woman who encouraged me to become a writer, and who was such a powerful and impassioned inspiration…as she will no doubt see when she reads my work. <em class="italic _idGenCharOverride-1">Amor siempre para siempre</em> Sikiu.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781788480116_EPUB4.vue?70c8d722